import * as React from "react";
export function Size(props) {
    let contour = props.drawing.calcContour();
    return React.createElement(React.Fragment, null,
        contour && React.createElement("span", null,
            Math.round(contour.width * 1000) / 1000,
            "mm x ",
            Math.round(contour.height * 1000) / 1000,
            " mm"),
        !contour && React.createElement("span", null, "No Contour"));
}
